import React, { useEffect, useState } from 'react';

export default function TokenUsageConsole() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchUsage = async () => {
      try {
        const res = await fetch('/api/admin/ai/usage');
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const json = await res.json();
        if (!cancelled) setData(json);
      } catch (e) {
        if (!cancelled) setError(String(e));
      }
    };
    fetchUsage();
    const id = setInterval(fetchUsage, 4000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  // Show the most recent completed request usage instead of the current usage endpoint request itself
  const recent = data?.lastCompleted ?? data?.current;
  const totals = data?.totals;

  const badge = (label, value, title) => (
      <div className="flex items-center gap-1 rounded border px-2 py-1 text-xs text-gray-700 dark:text-gray-200 border-gray-200 dark:border-gray-600" title={title}>
        <span className="font-medium text-gray-500 dark:text-gray-400">{label}:</span>
        <span className="font-semibold">{value ?? 0}</span>
      </div>
  );

  const elapsed = recent?.elapsedMs ? `${Math.round(recent.elapsedMs)}ms` : '—';

  return (
      <div className="hidden md:flex items-center gap-2">
        {error && (
            <div className="text-xs text-red-600" title={error}>AI usage n/a</div>
        )}
        {badge('Req prompt', recent?.promptTokens, 'Šios užklausos išsiųsti tokenai (prompt)')}
        {badge('Req completion', recent?.completionTokens, 'Šios užklausos gauti tokenai (completion)')}
        {badge('Req total', recent?.totalTokens, 'Viso tokenų šiai užklausai')}
        <div className="text-xs text-gray-500 ml-1" title="Nuo užklausos paleidimo">({elapsed})</div>
        <span className="mx-2 text-gray-300">|</span>
        {badge('All prompt', totals?.totalPromptTokens, 'Viso išsiųstų tokenų nuo programos starto')}
        {badge('All completion', totals?.totalCompletionTokens, 'Viso gautų tokenų nuo programos starto')}
        {badge('All total', totals?.totalTokens, 'Viso tokenų nuo programos starto')}
      </div>
  );
}
